import { render } from "./CourseworkMarkEntry.vue?vue&type=template&id=2d5043df"
import script from "./CourseworkMarkEntry.vue?vue&type=script&lang=js"
export * from "./CourseworkMarkEntry.vue?vue&type=script&lang=js"
script.render = render

export default script